import { lazyChunk } from "@/modules/lazyChunk";

export const McpChunk = lazyChunk(
  () => import("@/components/mcp/McpPlayer"),
  "mcp",
);
